import React from 'react';
import config from '../../../../config';

const { phone, email } = config.global.company;

const PhoneIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.75 6H13.25M12.006 16.9893H11.9662M16 21H8C6.895 21 6 20.105 6 19V5C6 3.895 6.895 3 8 3H16C17.105 3 18 3.895 18 5V19C18 20.105 17.105 21 16 21Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const MailIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.0975 9.1157L12.5923 11.8041C12.3151 11.9695 11.9745 11.9695 11.6972 11.8041L7.19746 9.11892M5.8 18.1249C4.80589 18.1249 4 17.2854 4 16.2499V6.875C4 5.83947 4.80589 5 5.8 5H18.4C19.3941 5 20.2 5.83947 20.2 6.875V16.25C20.2 16.7472 20.0103 17.2242 19.6728 17.5758C19.3352 17.9274 18.8773 18.125 18.3999 18.125L5.8 18.1249Z" stroke="#111111" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const OffersV4HelpContact = () => (
    <div className="offers-v4-help-contact">
        <hr className="offers-v4-help-contact__divider" />
        <div className="offers-v4-help-contact__content">
            <p className="offers-v4-help-contact__title">Need help?</p>
            <div className="offers-v4-help-contact__rows">
                <a className="offers-v4-help-contact__row" href={`tel:${phone.dash}`}>
                    <PhoneIcon />
                    <span className="offers-v4-help-contact__link">Call {phone.long}</span>
                </a>
                <a className="offers-v4-help-contact__row" href={`mailto:${email.support}`}>
                    <MailIcon />
                    <span className="offers-v4-help-contact__link">{email.support}</span>
                </a>
            </div>
        </div>
    </div>
);

export default OffersV4HelpContact;
